import React, { Component } from 'react';
import firebase from 'firebase/app';
import axios from 'axios';

import Jumbotron from 'react-bootstrap/Jumbotron'
import Form from 'react-bootstrap/Form'
import Footer from './task/Footer'
import Button from 'react-bootstrap/Button'
import { ToastContainer, toast } from 'react-toastify'
import ClipLoader from "react-spinners/ClipLoader";

import { firebaseApp } from './firebase/';
import { SignInButtons, onAuthStateChanged } from './task/SignInButtons'

import './InquiryApp.css';


const db = firebaseApp.firestore();

class InquiryApp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      user: undefined,
      error: null,
      mail: '',
      text: '',
      sent: false,
      sending: false,
    };
  }

  auth() {
    return this.props.auth || firebase.auth();
  }

  get db() {
    return this.props.db || db
  }

  componentDidMount() {
    onAuthStateChanged(this.auth(), (user, error) => {
      if (error) {
        this.setState({
          error,
        });
        return;
      }
      this.setState({ user });
    });
  }

  componentDidUpdate(prevProps, prevState) {
    this.emitErrorToast(prevState)
  }

  emitErrorToast(prevState) {
    if (prevState.error === this.state.error || this.state.error === null) {
      return
    }
    toast.error(`Error: ${this.state.error}`, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      onClose: () => this.setState({
        error: null
      })
    })
  }

  mailChange(event) {
    this.setState({
      mail: event.target.value,
    });
  }

  textChange(event) {
    this.setState({
      text: event.target.value,
    });
  }

  signIn(provider) {
    this.auth().signInWithRedirect(provider)
  }

  submit() {
    this.setState({
      sending: true,
      error: null,
    }, () => {
      this.performSubmit()
        .then(data => {
          console.log('Sent', data);
          this.setState({
            sent: true,
            sending: false,
          });
        })
        .catch(error => {
          console.error(error);
          this.setState({
            sent: false,
            sending: false,
            error: error.message || error,
          });
        });
    });
  }

  async performSubmit() {
    const content = {
      time: Date.now(),
      mail: this.state.mail,
      text: this.state.text,
    }
    await this.db
      .collection('user').doc(this.state.user.uid)
      .collection('mail').add(content);
    await axios.post(`/user/${this.state.user.uid}/mail`);
    return content;
  }

  renderForm() {
    return <>
      <Jumbotron className='InquiryTitle'>
        <h1>Cloze Testアプリ お問い合わせフォーム</h1>
      </Jumbotron>
      <p>
        本アプリに関するお問い合わせは以下のフォームからお願いします。追って、メールにてご連絡差し上げます。
      </p>
      {!this.state.sent && <>
          {this.sending && <div>送信中です...</div>}
          <Form.Group>
            <Form.Label>ユーザID</Form.Label>
            <Form.Control
              name='uid'
              readOnly={true}
              disabled={true}
              value={this.state.user && this.state.user.uid}
              placeholder='読み込んでいます...' />
            <small className="form-text text-muted">
              お問い合わせに関する状況の確認に使用します。
            </small>
          </Form.Group>
          <Form.Group>
            <Form.Label>連絡先メールアドレス</Form.Label>
            <Form.Control
              name='title'
              data-testid='mail'
              disabled={this.state.sending}
              placeholder='連絡先メールアドレスを入力してください。'
              onChange={ev => this.mailChange(ev)} />
            <small className="form-text text-muted">
              お問い合わせへの返信の目的にのみ利用します。
            </small>
          </Form.Group>
          <Form.Group>
            <Form.Label>お問い合わせ内容</Form.Label>
            <Form.Control
              as='textarea'
              name='text'
              data-testid='text'
              rows='20'
              disabled={this.state.sending}
              placeholder='お問い合わせの内容を入力してください。'
              onChange={ev => this.textChange(ev)} />
            <small className="form-text text-muted">
              問題の発生状況など、質問内容を記入してください。
              氏名等の個人情報はできる限り記載しないようにしてください。
            </small>
          </Form.Group>
          <div className='InquirySubmit'>
            <Button
              data-testid='submit'
              disabled={this.state.sending || !this.state.text || !this.state.mail}
              onClick={() => this.submit()}
              variant='success'>
              送信
            </Button>
          </div>
        </>}
      {this.state.sent && <div>
          送信しました。
        </div>}
    </>
  }

  render() {
    return <div className='InquiryApp'>
      {this.state.user === undefined && <div className='Loading'>
          <ClipLoader />
          <div data-testid='loading'>Loading...</div>
        </div>}
      {this.state.user && this.renderForm()}
      {this.state.user === null && <Jumbotron>
          <h1>Cloze Testアプリ お問い合わせフォーム</h1>
          <SignInButtons
            description='お問い合わせフォームに入力するためには、'
            signIn={(provider) => this.signIn(provider)}
          />
        </Jumbotron>}
      <Footer />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        />
    </div>
  }
}

export default InquiryApp;
